import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PrimengSeverities } from '@core/enums/primeng-severities';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private translate: TranslateService,
    private message: MessageService
  ) { }

  show(
    severity: PrimengSeverities,
    summaryTranslateKey: string,
    detailTranslateKey?: string,
    summaryParams?: object,
    detailParams?: object
  ): void {
    this.message.add({
      key: 'global-top-center',
      life: 3000,
      severity,
      summary: this.translate.instant(summaryTranslateKey, summaryParams),
      detail: detailTranslateKey ? this.translate.instant(detailTranslateKey, detailParams) : undefined
    });
  }

  clear(): void {
    this.message.clear();
  }
}
